import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';
import { getAddformMeta } from '../../../../shared/api/getAddformMeta';
import { IOfferState } from '../../../../shared/redux/reducers';
import { IGeoService } from './geoService';

export const getAddFormMetaService = [
  'httpApi', 'logger', 'geoService',
  (httpApi: IHttpApi, logger: ILogger, geoService: IGeoService) => {
    const run = async (offer: IOfferState) => {
      if (!offer) {
        return {};
      }

      const regionId = geoService.getLocationId() as number;

      const { category = '', isByHomeowner, id } = offer;

      return getAddformMeta({ httpApi, logger }, { category, isByHomeowner, regionId, offerId: id });
    };

    return {
      run,
    };
  },
];
